import { createSelector } from 'reselect';
import { selector } from './reducer';

export const searchTermSelector = createSelector(selector, (state) => state.searchTerm);
export const sortingSelector = createSelector(selector, (state) => state.sorting);
export const categoriesSelector = createSelector(selector, (state) => state.categories);
export const participantsSelector = createSelector(selector, (state) => state.participants);
export const participantgroupsSelector = createSelector(selector, (state) => state.participantgroups);
export const factiongroupsSelector = createSelector(selector, (state) => state.factiongroups);
export const kindSelector = createSelector(selector, (state) => state.kinds);
export const originSelector = createSelector(selector, (state) => state.origins);
export const statusSelector = createSelector(selector, (state) => state.statuses);
export const visibleSelector = createSelector(selector, (state) => state.visible);



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/filter/selectors.tsx